import { render, staticRenderFns } from "./queue-card.vue?vue&type=template&id=acd2623a&scoped=true"
import script from "./queue-card.vue?vue&type=script&lang=js"
export * from "./queue-card.vue?vue&type=script&lang=js"
import style0 from "./queue-card.vue?vue&type=style&index=0&id=acd2623a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd2623a",
  null
  
)

export default component.exports